<template>
        <v-navigation-drawer
          fixed          
          app
          width ="260"
          permanent
          class="transparent"
          :clipped="clip"    
         >
          <v-list>          
            <template v-for="(item,index) in nav_items">
              <template v-if="!item.group">              
              <v-list-tile :color="item.route_name == currentRoute? 'primary':''" :key="item.text" @click="selectOption(item.route)">
                <v-list-tile-action>
                  <v-icon :color="item.route_name == currentRoute? 'primary':''" v-bind:small="small" >{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="body-1 font-weight-regular">
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              </template>
              <template v-if="item.group">
                <v-divider v-if="item.submenu_status" :key="item.text+'c'"></v-divider>           
                <v-list-tile :key="item.text+'a'" @click="expandGroup(item.submenu_status,index,item.route)">
                  <v-list-tile-action>
                    <v-icon :color="item.route_name == currentRoute? 'primary':''" v-bind:small="small" >{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-1 font-weight-regular">
                      {{ item.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>                  
                  <v-list-tile-action>
                    <v-icon v-if="item.submenu_status" color="primary" v-bind:small="small" >keyboard_arrow_up</v-icon>
                    <v-icon v-if="!item.submenu_status" v-bind:small="small" >keyboard_arrow_down</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <div v-if="item.submenu_status" :key="item.text+'b'">
                <template v-for="(smenu,smindex) in item.submenus">
                  <v-list-tile :color="gindex == smindex ? 'primary':''" :key="smenu.text" @click="selectOption(smenu.route)">
                  <v-list-tile-action>                   
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title class="caption font-weight-regular">
                      {{ smenu.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  </v-list-tile>
                </template>
                </div>  
                <v-divider v-if="item.submenu_status" :key="item.text+'d'"></v-divider>                                
              </template>  
            </template>
      </v-list>
      <template>
       <div class="ma-2 red--text">App Still in development mode.</div>
       <div class="ma-2 red--text">Any one can use for free now.</div>
      </template> 
    </v-navigation-drawer>
</template>


<script>
export default { 
  data:() => ({
    clip:true,
    small: true,
    pageid:null,
    gindex: null,
    keyboard_arrow_down:'keyboard_arrow_down',
    keyboard_arrow_up:'keyboard_arrow_up',
    nav_items: [
        { group:false, submenu_status:false, icon: 'fa-th-large', text: 'Dashboard', route_name:"dashboard", route: '/dashboard'},
        { group:false,submenu_status:false, icon: 'perm_media', text: 'Assets', route_name:"assets", route: '/assets/'},
        { group:true, submenu_status:false ,icon: 'fa-robot', text: 'Automation', route_name:"automation", route: '/automation/responses/',
          submenus:[
            {text: 'Keywords', code:"keywords", route: '/automation/keywords/'},
            {text: 'Responses', code:"responses", route: '/automation/responses/'}
          ]
        },
  //      { s_no:0, icon: 'fa-comments', text: 'Inbox/Live chat'},
        { group:true,submenu_status:false,icon: 'send', text: 'Messaging', route_name:"broadcast", route: '/broadcast/templates/',
          submenus:[
            // {text: 'Broadcast Now', code:"bnow", route: '/broadcast/bnow/'},
            {text: 'Templates', code:"templates", route: '/broadcast/templates/'},
            {text: 'Send tagged Message', code:"taggedmessage", route: '/broadcast/taggedmessage/'},
           // {text: 'Sponsored Messaging', code:"sponseredmessage", route: '/broadcast/sponsoredmessage/'},
           // {text: 'Non Promotional Messaging', code:"nonpromomessage", route: '/broadcast/nonpromomessage/'},
            // {text: 'Labels', code:"labels", route: '/broadcast/labels/'},

          ]
        },
        { group:true,submenu_status:false,icon: 'fa-cog', text: 'Settings', route_name:"settings", route: '/settings/ps/',
          submenus:[
            {text: 'Page Settings', code:"ps",route: '/settings/ps/'},
            {text: 'Persistance Menu', code:"pm", route: '/settings/pm/'},
            {text: 'Getstarted Note', code:"gn", route: '/settings/gn/'},
            {text: 'Domain Whitelisting', code:"dw", route: '/settings/dw/'},
            // {text: 'Publish Bot', code:"pb", route: '/settings/pb/'}
          ]
        },
        { group:false,submenu_status:false,icon: 'fa-users', text: 'Users', route_name:"users", route: '/users/'},
        { group:true,submenu_status:false, icon: 'fa-wrench', text: 'Tools', route_name:"tools", route: '/tools/wp/',
            submenus:[
            {text: 'Webpluigns', code:"wp", route: '/tools/wp/'},
           // {text: 'Messenger Codes', code:"mc" , route: '/tools/mc/'},
            {text: 'Messenger refs' , code:"refs", route: '/tools/refs/'},
            {text: 'Comments' , code:"comments", route: '/tools/comments/'}
          ]
        },
  //      { icon: 'fa-chart-line', text: 'Insights'},
  //      { icon: 'fa-window-maximize', text: 'Templates'},
        { group:false,submenu_status:false,icon: 'fa-asterisk', text: 'Integrations', route_name:"integrations", route: '/integrations/'},
        { group:false,submenu_status:false,icon: 'fa-chart-line', text: 'Analysis', route_name:"analysis", route: '/analysis/'},
        { group:false,submenu_status:false,icon: 'fa-question-circle', text: 'Help', route_name:"help", route: '/help/'}
      ]
  }  
  ),
  methods:{
    selectOption(option){
      if (option != '/dashboard'){
      this.pageid = this.$store.state.selectedPage
      this.$router.push(option+this.pageid)
      }
      else{
        this.$router.push(option)
      }
    },
    expandGroup(gstatus, index, option){
      if(gstatus == false){
        if (this.gindex != null){
          this.pageid = this.$store.state.selectedPage
          this.$router.push(option+this.pageid)
          this.nav_items[index].submenu_status = !this.nav_items[index].submenu_status
          this.gindex = index
        } 
        else if(this.gindex == null){
        this.pageid = this.$store.state.selectedPage
        this.$router.push(option+this.pageid)
        this.nav_items[index].submenu_status = !this.nav_items[index].submenu_status
        this.gindex = index
        }
      }
      else if (gstatus == true){
        if (this.gindex != null){
          this.nav_items[index].submenu_status = !this.nav_items[index].submenu_status
          this.gindex = index
        } 
        else if(this.gindex == null){
        this.nav_items[index].submenu_status = !this.nav_items[index].submenu_status
        this.gindex = index
        }
      }
    }

  },
  computed:{
    currentRoute(){
      let r_name = this.$route.name
      let s_menu_value = this.$route.params.s_menu
      console.log(s_menu_value)
      if (s_menu_value != undefined)
      {
        let index = this.nav_items.findIndex(item => item.route_name == r_name)
        console.log(this.nav_items[index])
        this.nav_items[index].submenu_status = true
        let smenuindex = this.nav_items[index].submenus.findIndex(item => item.code == s_menu_value)
        console.log(smenuindex)
        if (smenuindex != null || smenuindex != undefined){
          this.gindex = smenuindex
          console.log(this.gindex)
          }
      }
      return r_name
    }
  }
  }

</script>

<style scoped>

</style>

